import {ref, Ref} from "vue";
import type { Component } from "vue";

export default class BlockViewer {

    private container: null | HTMLElement = null as HTMLElement | null;
    private static instance: BlockViewer;
    private static creating: boolean = false;
    private onShowListeners: (() => void)[] = [];
    private component: Ref<Component | null> = ref(null);
    private componentProps: Ref<Record<string, any>> = ref({});

    static getInstance(): BlockViewer {
        if (!BlockViewer.instance) {
            BlockViewer.creating = true;
            BlockViewer.instance = new BlockViewer();
            BlockViewer.creating = false;
        }
        return BlockViewer.instance;
    }

    public addOnShowListener(listener: () => void) {
        this.onShowListeners.push(listener);
    }

    public init(container: HTMLElement, component: Ref<Component | null>, blockProps: Ref<Record<string, any>>) {
        this.container = container;
        this.component = component;
        this.componentProps = blockProps;
    }

    public show(component: Component, props: any) {
        this.componentProps.value = props
        this.component.value = component;
        this.onShowListeners.forEach(listener => listener());
    }

    public destroy() {

    }
}
